import { render, staticRenderFns } from "./TrainingAccessSettings.vue?vue&type=template&id=dc1ef9ea&"
import script from "./TrainingAccessSettings.vue?vue&type=script&lang=js&"
export * from "./TrainingAccessSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports